var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUaeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0.875H32V23.2857H0.625V0.875Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0.875H32V8.15848H0.625V0.875Z",
    fill: "#32AB45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 16.0022H32V23.2857H0.625V16.0022Z",
    fill: "#1D1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0.875H9.58929V23.2857H0.625V0.875Z",
    fill: "#E92B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaeFlag);
export default __webpack_public_path__ + "static/media/uae-flag.6bceae5ed4f8e5109561fff6d28a2f47.svg";
export { ForwardRef as ReactComponent };